import React, { useState } from 'react'
import { InviteAcceptForm } from '../components/auth/InviteAcceptForm'
import { LoginForm } from '../components/auth/LoginForm'
import { SignupForm } from '../components/auth/SignupForm'
import { useI18n } from '../i18n/I18nContext'
import { navigateTo } from '../services/navigation'
import { authReturnPath } from '../services/authReturn'

export const AuthPage: React.FC = () => {
  const { t } = useI18n()
  const [isSignup, setIsSignup] = useState(false)
  const inviteToken = typeof window !== 'undefined'
    ? window.location.pathname.match(/^\/org-invites\/([^/]+)$/)?.[1] || ''
    : ''
  const handleLoginSuccess = () => {
    if (typeof window === 'undefined') return
    const destination = authReturnPath(window.location.search)
    // Standalone Social Admin is selected by App's top-level route resolver,
    // so re-bootstrap the bundle after authentication instead of leaving the
    // already-mounted workforce AuthGuard in control.
    if (destination === '/social-admin' || destination.startsWith('/social-admin/')) {
      window.location.replace(destination)
      return
    }
    navigateTo(destination, { replace: true, notify: false })
  }

  return (
    <div className="auth-layout" data-testid="auth-page">
      <section className="panel auth-card stack-lg">
        <header className="stack" style={{ gap: '0.4rem' }}>
          <h1 className="heading-lg">{inviteToken ? t('Accept Invitation') : t('Administrator Access')}</h1>
          <p className="text-muted">
            {inviteToken
              ? t('Join the organization scope selected by your administrator.')
              : isSignup
              ? t('Create your admin account and first agency or company workspace.')
              : t('Sign in with your administrator account to manage shifts and enterprise tools.')}
          </p>
        </header>

        {inviteToken ? <InviteAcceptForm token={inviteToken} /> : isSignup ? <SignupForm onSuccess={() => setIsSignup(false)} /> : <LoginForm onSuccess={handleLoginSuccess} />}

        {!inviteToken ? <footer className="stack" style={{ gap: '0.35rem', borderTop: '1px solid var(--auth-border)', paddingTop: '0.9rem' }}>
          <p className="text-muted">
            {isSignup ? t('Already have an account? ') : t("Don't have an account? ")}
            <button
              onClick={() => setIsSignup(!isSignup)}
              className="link-button"
              style={{ fontWeight: 700 }}
              data-testid="auth-toggle"
            >
              {isSignup ? t('Sign in') : t('Create account')}
            </button>
          </p>
          {!isSignup && <p className="helper">{t('New admins can create an agency or company workspace from the signup flow.')}</p>}
        </footer> : null}
      </section>
    </div>
  )
}
